import { render } from "./ShiftsPage.vue?vue&type=template&id=0a8e6b4d&scoped=true&ts=true"
import script from "./ShiftsPage?vue&type=script&lang=ts"
export * from "./ShiftsPage?vue&type=script&lang=ts"

import "./ShiftsPage.vue?vue&type=style&index=0&id=0a8e6b4d&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8e6b4d"]])

export default __exports__